/* Jamilah v2 theme JS — variant picker, quick add, cart, sticky bar, menu, countdowns */
(function () {
  'use strict';

  /* Liquid renders every price first and this file overwrites it on load and on
     every variant change, so the output here has to be byte-identical to the
     Liquid filter it replaces. Shopify's `amount` placeholder means comma
     thousands separators and always two decimals; `money_without_trailing_zeros`
     is the same number with a bare `.00` dropped - the grouping stays either
     way. The symbol and placement still come from the shop's money format. */
  function groupThousands(digits) {
    return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function formatAmount(cents, dropZeroCents) {
    var n = Number(cents);
    if (!isFinite(n)) n = 0;
    var fixed = (Math.abs(n) / 100).toFixed(2);
    var parts = fixed.split('.');
    var amount = groupThousands(parts[0]);
    if (!(dropZeroCents && parts[1] === '00')) amount += '.' + parts[1];
    return (n < 0 ? '-' : '') + amount;
  }
  function applyMoneyFormat(amount) {
    var fmt = window.JamilahMoneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }
  /* money() mirrors `| money`; moneyNoZeros() mirrors
     `| money_without_trailing_zeros`. Use whichever the Liquid for that same
     element uses, or the value will visibly change once JS runs. */
  var money = function (cents) { return applyMoneyFormat(formatAmount(cents, false)); };
  var moneyNoZeros = function (cents) { return applyMoneyFormat(formatAmount(cents, true)); };

  /* ---------- mobile menu ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-toggle]');
    if (!t) return;
    var menu = document.getElementById('MobileMenu');
    if (!menu) return;
    var open = menu.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- cart count ---------- */
  function setCartCount(n) {
    /* The badge must stay in the DOM at zero, because every caller finds it
       through this selector - so an empty cart hides it, never removes it. */
    var empty = !(Number(n) > 0);
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (empty) el.setAttribute('hidden', '');
      else el.removeAttribute('hidden');
    });
  }

  /* ---------- cart drawer ----------
     The drawer is rendered server-side by sections/cart-drawer.liquid and
     mounted once in layout/theme.liquid. After any cart mutation we re-fetch
     /?section_id=cart-drawer and swap the inner HTML, so money formatting,
     discounts and line properties stay in Liquid and are never rebuilt here.
     Every entry point is guarded: on a page with no #CartDrawer, nothing
     throws and links fall back to their real hrefs. */
  var DRAWER_ID = 'CartDrawer';
  var DRAWER_ANIM_MS = 300;
  var DRAWER_SHOW_FALLBACK_MS = 100;
  var DRAWER_SAFETY_MS = 700;
  var drawerReturnFocus = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function getDrawer() { return document.getElementById(DRAWER_ID); }
  /* layout/theme.liquid renders body class="template-{{ request.page_type | handle }}",
     which is `template-cart` on /cart. The pathname test is only a fallback for
     a locale-prefixed or proxied URL where that class might be missing. */
  function isCartPage() {
    if (document.body && document.body.classList.contains('template-cart')) return true;
    return /(^|\/)cart\/?$/.test(window.location.pathname);
  }
  function getDrawerPanel() {
    var d = getDrawer();
    return d ? d.querySelector('[data-cart-drawer-panel]') : null;
  }
  function drawerIsOpen() {
    var d = getDrawer();
    return !!d && d.classList.contains('is-open');
  }
  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function setDrawerInert(on) {
    var d = getDrawer();
    if (!d) return;
    if (on) {
      d.setAttribute('hidden', '');
      if ('inert' in d) d.inert = true; else d.setAttribute('inert', '');
    } else {
      d.removeAttribute('hidden');
      if ('inert' in d) d.inert = false; else d.removeAttribute('inert');
    }
  }

  /* Everything behind the drawer goes inert while it is open, so pointer and
     virtual-cursor users are held inside the dialog too, not just Tab users.
     Browsers without inert support fall back to the keydown trap below. */
  var inertedNodes = [];
  function supportsInert() {
    return typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
  }
  function setBackgroundInert(on) {
    if (!supportsInert()) return;
    if (!on) {
      inertedNodes.forEach(function (el) { el.inert = false; });
      inertedNodes = [];
      return;
    }
    var d = getDrawer();
    if (!d) return;
    var top = d;
    while (top.parentElement && top.parentElement !== document.body) top = top.parentElement;
    inertedNodes = [];
    Array.prototype.forEach.call(document.body.children, function (el) {
      /* Skip the drawer's own branch, and anything already inert for other
         reasons - we must only give back what we took. */
      if (el === top || el.inert) return;
      el.inert = true;
      inertedNodes.push(el);
    });
  }

  /* A stable identity for a line control, so focus survives the section swap. */
  function controlKey(el) {
    if (!el || typeof el.getAttribute !== 'function') return null;
    var line = el.getAttribute('data-line');
    if (line === null) return null;
    if (el.hasAttribute('data-line-remove')) return { line: line, kind: 'remove' };
    if (el.hasAttribute('data-qty-input')) return { line: line, kind: 'input' };
    if (el.hasAttribute('data-qty-change')) return { line: line, kind: el.getAttribute('data-qty-change') };
    return null;
  }
  function controlSelector(key) {
    if (key.kind === 'remove') return '[data-line-remove][data-line="' + key.line + '"]';
    if (key.kind === 'input') return '[data-qty-input][data-line="' + key.line + '"]';
    return '[data-qty-change="' + key.kind + '"][data-line="' + key.line + '"]';
  }

  /* Disable every control on the line, not just the clicked button: the steppers
     read the sibling input's value, so a second click during an in-flight
     request would compute its delta from a stale quantity. */
  function lineControls(el) {
    var row = el.closest('.cart-drawer__line') || el.closest('.cart-line') || el.parentElement;
    if (!row) return [];
    return Array.prototype.slice.call(row.querySelectorAll('[data-qty-change], [data-qty-input], [data-line-remove]'));
  }
  function setControlsDisabled(nodes, off) {
    nodes.forEach(function (el) {
      /* Read-only, never disabled, for the quantity box: a disabled input cannot
         hold focus, so disabling the box the shopper is typing in would throw
         focus to the body mid-edit and drop it out of the drawer's focus trap.
         Read-only blocks typing while keeping the node focusable and its value
         intact. Locking the two stepper buttons is what actually closes the
         race - they read this input's value to compute their delta. */
      if (el.hasAttribute('data-qty-input')) el.readOnly = off;
      else el.disabled = off;
    });
  }

  /* One contract for both quantity paths - typing into the box, and the +/-
     steppers that read that same box to compute their delta. A blank or
     non-integer box is the normal middle of a mobile edit (tap the number,
     delete it, type the new one), never a request to remove the line: Number('')
     is 0 and 0 means remove. Restore the server-rendered value and return null
     so the caller bails out without touching the cart. input.defaultValue holds
     the value Liquid rendered, and both the drawer and the cart page re-render
     from the server after every change, so it is always the right value to go
     back to. Only an explicitly typed 0 removes a line. */
  function readQty(input) {
    var raw = String(input.value).trim();
    if (!/^\d+$/.test(raw)) {
      input.value = input.defaultValue;
      return null;
    }
    return Number(raw);
  }

  /* Shopify silently caps a quantity change at available stock when inventory
     is tracked with policy DENY: /cart/change.js answers 200 with the capped
     cart, so the only way to know is to compare what we asked for against what
     came back. Match on the line's key rather than its index - a removal
     renumbers every later line, so an index lookup would inspect the wrong
     item. */
  function lineKeyFor(el) {
    var row = el.closest('[data-line-key]');
    return row ? row.getAttribute('data-line-key') : null;
  }
  function findCartLine(cart, key, line) {
    if (!cart || !cart.items) return null;
    if (key) {
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === key) return cart.items[i];
      }
      return null;
    }
    return cart.items[line - 1] || null;
  }
  function quantityNotice(cart, key, line, requested) {
    /* Asking for 0 is a removal - the line is meant to disappear. */
    if (!(requested > 0)) return null;
    var item = findCartLine(cart, key, line);
    if (!item) return 'That item is no longer available.';
    if (item.quantity >= requested) return null;
    return 'Only ' + item.quantity + ' available.';
  }
  function cartErrorText(err) {
    return (err && err.cartMessage) || 'Sorry, that could not be updated. Please try again.';
  }

  function showDrawerError(msg) {
    var d = getDrawer();
    if (!d) return false;
    var el = d.querySelector('[data-cart-drawer-error]');
    if (!el) return false;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(showDrawerError.timer);
    showDrawerError.timer = setTimeout(function () {
      var live = getDrawer();
      var node = live && live.querySelector('[data-cart-drawer-error]');
      if (node) { node.hidden = true; node.textContent = ''; }
    }, 6000);
    return true;
  }

  function refreshDrawer() {
    var current = getDrawer();
    if (!current || typeof window.fetch !== 'function') return Promise.resolve(null);
    return fetch('/?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('drawer section fetch failed'); return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(DRAWER_ID);
        var live = getDrawer();
        if (!fresh || !live) return null;
        var active = document.activeElement;
        var focusWasInside = !!(active && live.contains(active));
        var key = focusWasInside ? controlKey(active) : null;
        /* innerHTML, never outerHTML: the root node's identity must stay stable
           so that open state and any reference held elsewhere remain valid. */
        live.innerHTML = fresh.innerHTML;
        var count = fresh.getAttribute('data-cart-count-value');
        if (count !== null) { live.setAttribute('data-cart-count-value', count); setCartCount(count); }
        var statusText = fresh.getAttribute('data-cart-status');
        if (statusText !== null) live.setAttribute('data-cart-status', statusText);
        /* Only pull focus back if the swap destroyed the element that had it,
           and land on the same control on the same line where we can. */
        if (drawerIsOpen() && focusWasInside && !document.contains(active)) {
          var restored = key ? live.querySelector(controlSelector(key)) : null;
          if (restored) restored.focus();
          else {
            var p = getDrawerPanel();
            if (p) p.focus();
          }
        }
        /* Fill the live region after it is in the document, otherwise assistive
           tech sees an already-populated node and stays silent. */
        var status = live.querySelector('[data-cart-drawer-status]');
        if (status && statusText) {
          setTimeout(function () {
            var node = getDrawer() && getDrawer().querySelector('[data-cart-drawer-status]');
            if (node) node.textContent = statusText;
          }, 60);
        }
        return live;
      })
      .catch(function () {
        /* Keep the header count honest even if the section render failed. */
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (c) { setCartCount(c.item_count); return null; })
          .catch(function () { return null; });
      });
  }

  /* Unwind a failed open. Locking the page behind an overlay that never became
     visible is the worst outcome available, so any path that cannot finish
     opening must give scrolling and the background back. */
  function abandonOpen() {
    document.body.style.overflow = '';
    setBackgroundInert(false);
    setDrawerInert(true);
    drawerReturnFocus = null;
  }

  function openDrawer(opener) {
    var d = getDrawer();
    if (!d) return;
    if (d.classList.contains('is-open')) return;
    if (opener && document.contains(opener)) drawerReturnFocus = opener;
    else if (document.activeElement && document.activeElement !== document.body) drawerReturnFocus = document.activeElement;
    setDrawerInert(false);
    setBackgroundInert(true);
    document.body.style.overflow = 'hidden';

    var settled = false;
    var opened = false;
    var show = function () {
      if (settled) return;
      settled = true;
      /* Re-query instead of trusting a reference captured earlier: a section
         refresh may have run in between, and a class added to a detached node
         would leave the page locked behind an invisible overlay. */
      var live = getDrawer();
      var panel = live ? live.querySelector('[data-cart-drawer-panel]') : null;
      if (!live || !panel) { abandonOpen(); return; }
      live.classList.add('is-open');
      opened = true;
      panel.focus();
    };

    /* A frame of delay lets the browser paint the off-screen transform so the
       panel slides in. But requestAnimationFrame is paused in a background or
       otherwise unpainted tab, and a frozen page is far worse than a drawer
       that skips its animation - so a timer races the frames, first one wins. */
    if (reducedMotion() || typeof window.requestAnimationFrame !== 'function') show();
    else {
      window.requestAnimationFrame(function () { window.requestAnimationFrame(show); });
      setTimeout(show, DRAWER_SHOW_FALLBACK_MS);
    }

    /* Last resort for a cause we have not thought of: if the panel still is not
       open, hand the page back rather than stranding the shopper. */
    setTimeout(function () { if (!opened) abandonOpen(); }, DRAWER_SAFETY_MS);
  }

  function closeDrawer() {
    var d = getDrawer();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    document.body.style.overflow = '';
    var back = drawerReturnFocus;
    drawerReturnFocus = null;
    /* Release the background first - the opener usually lives in the header,
       and an inert element cannot take focus. */
    setBackgroundInert(false);
    /* Move focus out before the panel goes inert/hidden. */
    if (back && document.contains(back) && typeof back.focus === 'function') back.focus();
    if (reducedMotion()) setDrawerInert(true);
    else setTimeout(function () { if (!drawerIsOpen()) setDrawerInert(true); }, DRAWER_ANIM_MS);
  }

  function trapDrawerFocus(e) {
    var p = getDrawerPanel();
    if (!p) return;
    var nodes = Array.prototype.filter.call(p.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
    if (!nodes.length) { e.preventDefault(); p.focus(); return; }
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    var active = document.activeElement;
    if (e.shiftKey) {
      if (active === first || active === p || !p.contains(active)) { e.preventDefault(); last.focus(); }
    } else if (active === last || !p.contains(active)) {
      e.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('keydown', function (e) {
    if (!drawerIsOpen()) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closeDrawer(); return; }
    if (e.key === 'Tab') trapDrawerFocus(e);
  });

  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;
    if (e.target.closest('[data-cart-drawer-close]') || e.target.closest('[data-cart-drawer-overlay]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    /* Header bag icon: the anchor keeps its real href to /cart for the no-JS
       case, so only hijack a plain left click and only when a drawer exists. */
    var bagLink = e.target.closest('.site-header__utils a[href]');
    if (!bagLink || !bagLink.querySelector('[data-cart-count]')) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button && e.button !== 0)) return;
    if (!getDrawer()) return;
    /* On /cart the drawer would float over the very thing it duplicates, and a
       quantity edited inside it leaves the page behind it showing stale
       server-rendered values. Let the anchor's own href to /cart run instead. */
    if (isCartPage()) return;
    e.preventDefault();
    openDrawer(bagLink);
    refreshDrawer();
  });

  /* Typing a quantity straight into a stepper input - in the drawer, or on the
     cart page where the input is no longer part of the checkout form and so has
     to do the work itself. The drawer re-renders its section; the cart page
     reloads, which is exactly what its own +/- buttons already do. */
  document.addEventListener('change', function (e) {
    if (!(e.target instanceof Element)) return;
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var d = getDrawer();
    var inDrawer = !!(d && d.contains(input));
    /* A blank or non-integer box restores itself and makes no request - see
       readQty(). quantityNotice() returns null for a requested 0, so without
       this the line would vanish with nothing shown at all. */
    var qty = readQty(input);
    if (qty === null) return;
    var line = Number(input.getAttribute('data-line'));
    var controls = lineControls(input);
    var key = lineKeyFor(input);
    setControlsDisabled(controls, true);
    cartChange(line, qty)
      .then(function (cart) {
        if (!inDrawer) { window.location.reload(); return; }
        var notice = quantityNotice(cart, key, line, qty);
        return refreshDrawer().then(function (live) {
          if (!live) setControlsDisabled(controls, false);
          if (notice) showDrawerError(notice);
        });
      })
      .catch(function (err) {
        setControlsDisabled(controls, false);
        if (inDrawer) { showDrawerError(cartErrorText(err)); return; }
        /* Cart page: a server rejection leaves the page stale, so re-render it.
           A network failure changed nothing, so leave the page alone. */
        if (err && err.cartError) window.location.reload();
      });
  });

  /* ---------- announcement countdown ---------- */
  document.querySelectorAll('[data-countdown-to]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-countdown-to'));
    if (isNaN(end.getTime())) return;
    var h = el.querySelector('[data-cd-h]'), m = el.querySelector('[data-cd-m]'), s = el.querySelector('[data-cd-s]');
    function tick() {
      var diff = end.getTime() - Date.now();
      if (diff <= 0) { el.hidden = true; return; }
      el.hidden = false;
      h.textContent = Math.floor(diff / 3600000);
      m.textContent = Math.floor(diff % 3600000 / 60000);
      s.textContent = Math.floor(diff % 60000 / 1000);
      setTimeout(tick, 1000);
    }
    tick();
  });

  /* ---------- delivery estimate ---------- */
  document.querySelectorAll('[data-delivery]').forEach(function (el) {
    var cutoffHour = Number(el.getAttribute('data-cutoff-hour') || 14);
    var transit = Number(el.getAttribute('data-transit-days') || 3);
    var cdEl = el.querySelector('[data-delivery-countdown]');
    var dateEl = el.querySelector('[data-delivery-date]');
    function nextBusinessDay(d) {
      do { d.setDate(d.getDate() + 1); } while (d.getDay() === 0 || d.getDay() === 6);
      return d;
    }
    function compute() {
      var now = new Date();
      var cutoff = new Date(now);
      cutoff.setHours(cutoffHour, 0, 0, 0);
      var dispatch = new Date(now);
      if (now > cutoff || dispatch.getDay() === 0 || dispatch.getDay() === 6) {
        dispatch = nextBusinessDay(dispatch);
        cutoff = new Date(dispatch);
        cutoff.setHours(cutoffHour, 0, 0, 0);
      }
      var delivery = new Date(dispatch);
      for (var i = 0; i < transit; i++) delivery = nextBusinessDay(delivery);
      if (dateEl) dateEl.textContent = delivery.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      if (cdEl) {
        var diff = cutoff.getTime() - now.getTime();
        var hrs = Math.floor(diff / 3600000);
        var mins = Math.ceil(diff % 3600000 / 60000);
        cdEl.textContent = hrs > 0 ? hrs + ' hr ' + mins + ' min' : mins + ' min';
      }
    }
    compute();
    setInterval(compute, 60000);
  });

  /* ---------- quick add (single-variant products) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-quick-add');
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        setCartCount(cart.item_count);
        btn.setAttribute('data-added', '');
        setTimeout(function () { btn.removeAttribute('data-added'); btn.disabled = false; }, 1600);
        return refreshDrawer().then(function () { openDrawer(btn); });
      })
      .catch(function () {
        btn.disabled = false;
        /* Inside the drawer a hard navigation would throw the shopper out of
           the overlay, so surface the failure in place instead. */
        var d = getDrawer();
        if (d && d.contains(btn) && showDrawerError('Sorry, that could not be added. Please try again.')) return;
        window.location.href = btn.getAttribute('data-url') || '/cart';
      });
  });

  /* ---------- product form ---------- */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('[name="id"]');
    var multiplier = 2.5;
    var fair = root.querySelector('[data-fair-pricing]');
    if (fair) multiplier = Number(fair.getAttribute('data-multiplier') || 25) / 10;

    function currentOptions() {
      var opts = [];
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts[Number(group.getAttribute('data-option-index'))] = checked.value;
      });
      return opts;
    }
    function currentVariant() {
      /* Single-variant products render no option pickers, so currentOptions()
         is empty and the match below can never succeed. Short-circuit. */
      if (product.variants.length === 1) return product.variants[0];
      var opts = currentOptions();
      if (!opts.length) return product.variants[0];
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function markAvailability() {
      var opts = currentOptions();
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var idx = Number(group.getAttribute('data-option-index'));
        group.querySelectorAll('.seg-opt').forEach(function (opt) {
          var input = opt.querySelector('input');
          if (!input) return;
          var test = opts.slice();
          test[idx] = input.value;
          var match = product.variants.find(function (v) {
            return v.options.every(function (o, i) { return o === test[i]; });
          });
          var off = !match || !match.available;
          opt.classList.toggle('is-disabled', off);
          input.disabled = off && !input.checked;
        });
      });
    }

    /* Variant announcements. [data-variant-status] is rendered empty by
       sections/main-product.liquid and filled only from here - the same
       contract sections/cart-drawer.liquid uses for [data-cart-drawer-status]:
       write into a live region that is already in the document, and clear it
       first so an identical repeat message still reads as a change. Only the
       option inputs' change handler asks for an announcement, so nothing is
       announced on the initial paint. */
    var statusEl = root.querySelector('[data-variant-status]');
    var announceTimer = null;
    function variantAnnouncement(v) {
      if (!v) return 'This combination is not available';
      var name = (v.title === 'Default Title') ? product.title : v.title.split(' / ').join(', ');
      var state = v.available
        ? (root.getAttribute('data-stock-text') || 'In stock')
        : (root.getAttribute('data-soldout-text') || 'Sold out');
      return name + ', ' + money(v.price) + ', ' + state;
    }
    function announceVariant(v) {
      if (!statusEl) return;
      var msg = variantAnnouncement(v);
      statusEl.textContent = '';
      clearTimeout(announceTimer);
      announceTimer = setTimeout(function () { statusEl.textContent = msg; }, 60);
    }

    function setUnavailable(root, isUnavailable) {
      var stock = root.querySelector('[data-stock-line]');
      var dot = root.querySelector('[data-stock-dot]');
      var atc = root.querySelector('[data-atc]');
      if (stock) stock.textContent = isUnavailable ? 'This combination is not available' : stock.textContent;
      if (dot) dot.classList.toggle('stock-dot--warn', isUnavailable);
      if (atc) {
        atc.disabled = isUnavailable;
        if (isUnavailable) atc.textContent = 'Unavailable';
      }
      /* The bar button is the only purchase control on a phone, and its handler
         is a no-op when [data-atc] is disabled - so an enabled-looking bar is a
         dead button. Mirror the real button's state and its label. */
      var barBtn = document.querySelector('[data-sticky-atc] button');
      if (barBtn) {
        barBtn.disabled = isUnavailable;
        if (isUnavailable) barBtn.textContent = 'Unavailable';
        else if (atc) barBtn.textContent = atc.textContent;
      }
    }

    /* ---------- gallery follows the selected variant ---------- */
    var gallery = root.querySelector('[data-gallery]');
    var galleryFlash = null;

    /* Fraction of the frame that is on screen, measured against the most that
       could be on screen - so a frame taller than the viewport still scores 1
       once it fills the viewport, instead of being scrolled at forever. */
    function visibleRatio(el) {
      var r = el.getBoundingClientRect();
      var vw = window.innerWidth || document.documentElement.clientWidth;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var cx = Math.min(r.width, vw);
      var cy = Math.min(r.height, vh);
      if (cx <= 0 || cy <= 0) return 0;
      var ox = Math.max(0, Math.min(r.right, vw) - Math.max(r.left, 0));
      var oy = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
      return (ox / cx) * (oy / cy);
    }

    function showVariantMedia(v) {
      /* Most variants in this catalogue have no image of their own. That is the
         ordinary case, not an error - leave the gallery alone and say nothing. */
      if (!gallery || !v || !v.featured_media) return;
      var target = gallery.querySelector('[data-gallery-media="' + v.featured_media.id + '"]');
      if (!target) return;

      /* Acknowledge the match even when no scroll is needed. The frame can be on
         screen and still be a long way from the picker that was just used. */
      target.classList.remove('is-variant-target');
      void target.offsetWidth;
      target.classList.add('is-variant-target');
      clearTimeout(galleryFlash);
      galleryFlash = setTimeout(function () { target.classList.remove('is-variant-target'); }, 900);

      /* Already substantially in view - a jump when nothing needed to move is
         worse than doing nothing. */
      if (visibleRatio(target) >= 0.6) return;

      /* block:'nearest' at every breakpoint. It scrolls the minimum needed, so
         the option picker the shopper just touched stays where they left it.
         'center' re-centres the frame every time, and on the desktop two-column
         layout (.pdp 7fr/5fr, gallery beside the buy column) that extra travel
         can carry the picker out of the viewport.
         At <=900px .pdp__grid is a horizontal scroll-snap carousel, so the frame
         is already at the right height and only the carousel needs to move -
         inline:'center' matches its scroll-snap-align and the page itself does
         not scroll at all. On desktop the grid has no horizontal overflow, so
         'nearest' there keeps it from nudging sideways. */
      var isCarousel = gallery.scrollWidth > gallery.clientWidth + 1;
      var startY = window.pageYOffset;
      var startX = gallery.scrollLeft;
      function go(behavior) {
        try {
          target.scrollIntoView({
            behavior: behavior,
            block: 'nearest',
            inline: isCarousel ? 'center' : 'nearest'
          });
        } catch (err) {
          /* Older engines reject the options object. Silent fallback. */
          target.scrollIntoView(false);
        }
      }
      if (reducedMotion()) { go('auto'); return; }
      go('smooth');
      /* Some browsers drop a smooth scroll on the floor rather than performing
         it instantly - Chrome with smooth scrolling switched off, and some OS
         "reduce animation" settings that never reach the media query above.
         We only get here when the frame genuinely needs to move, so nothing
         having moved shortly after means the request was ignored. Not moving at
         all is the one outcome worse than an unanimated jump, so re-issue it
         without the animation. */
      setTimeout(function () {
        if (window.pageYOffset === startY && gallery.scrollLeft === startX) go('auto');
      }, 250);
    }

    function render(announce) {
      var v = currentVariant();
      markAvailability();
      if (!v) {
        setUnavailable(root, true);
        var deadBar = document.querySelector('[data-sticky-atc]');
        if (deadBar) {
          var dbv = deadBar.querySelector('[data-bar-variant]');
          var dbp = deadBar.querySelector('[data-bar-price]');
          if (dbv) dbv.textContent = 'This combination is not available';
          if (dbp) dbp.textContent = '';
        }
        if (announce) announceVariant(null);
        return;
      }
      setUnavailable(root, false);
      if (idInput) idInput.value = v.id;
      root.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = money(v.price); });
      root.querySelectorAll('[data-compare-price]').forEach(function (el) {
        el.innerHTML = (v.compare_at_price && v.compare_at_price > v.price) ? '<s>' + money(v.compare_at_price) + '</s>' : '';
      });
      root.querySelectorAll('[data-off-chip]').forEach(function (el) {
        /* Liquid renders this chip with money_without_trailing_zeros. */
        el.innerHTML = (v.compare_at_price && v.compare_at_price > v.price)
          ? '<span class="badge badge--off">' + moneyNoZeros(v.compare_at_price - v.price) + ' OFF</span>' : '';
      });
      root.querySelectorAll('[data-installment]').forEach(function (el) {
        el.textContent = money(Math.round(v.price / 4));
      });
      /* The fair-pricing card is rendered with money_without_trailing_zeros. */
      var us = root.querySelector('[data-fair-us]');
      var them = root.querySelector('[data-fair-them]');
      if (us) us.textContent = moneyNoZeros(v.price);
      if (them && !them.hasAttribute('data-fixed')) them.textContent = moneyNoZeros(Math.round(v.price * multiplier));
      var stock = root.querySelector('[data-stock-line]');
      var dot = root.querySelector('[data-stock-dot]');
      var atc = root.querySelector('[data-atc]');
      if (stock && dot && atc) {
        if (!v.available) {
          stock.textContent = root.getAttribute('data-soldout-text') || 'Sold out';
          dot.classList.add('stock-dot--warn');
          atc.disabled = true;
          atc.textContent = stock.textContent;
        } else {
          stock.textContent = root.getAttribute('data-stock-text') || 'In stock';
          dot.classList.remove('stock-dot--warn');
          atc.disabled = false;
          atc.textContent = root.getAttribute('data-atc-text') || 'Add to cart';
        }
      }
      var bar = document.querySelector('[data-sticky-atc]');
      if (bar) {
        var bv = bar.querySelector('[data-bar-variant]');
        var bp = bar.querySelector('[data-bar-price]');
        if (bv) bv.textContent = v.title === 'Default Title' ? product.title : v.title.split(' / ').join(' · ');
        if (bp) bp.textContent = money(v.price);
        /* Mirror [data-atc] onto the bar in BOTH branches above - a sold-out
           variant must reach the bar as a disabled, sold-out-labelled button,
           and switching back to an available one must re-enable it. */
        var bb = bar.querySelector('button');
        if (bb && atc) { bb.disabled = atc.disabled; bb.textContent = atc.textContent; }
      }
      /* Only a user-initiated pick moves the gallery. render() also runs on the
         initial paint and on the reset after a successful add, and neither of
         those should scroll the page. */
      if (announce) showVariantMedia(v);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (err) {}
      if (announce) announceVariant(v);
    }

    root.querySelectorAll('[data-option-index] input').forEach(function (input) {
      /* Only a user-initiated change asks for an announcement. render() is also
         called on the initial paint and on the reset after a successful add,
         and neither of those should speak. */
      input.addEventListener('change', function () { render(true); });
    });
    render();

    var form = root.querySelector('form[data-product-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = currentVariant();
        /* No matching variant means the shopper picked a combination that does
           not exist. Never fall through to a native POST here - the hidden id
           input still holds the last resolvable variant, so posting would add
           the wrong item to the cart. */
        if (!v) { setUnavailable(root, true); announceVariant(null); return; }
        if (!v.available) return;
        var atc = root.querySelector('[data-atc]');
        if (atc) atc.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: v.id, quantity: 1 })
        })
          .then(function (r) { if (!r.ok) throw new Error(); return fetch('/cart.js'); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            setCartCount(cart.item_count);
            if (atc) { atc.setAttribute('data-added', ''); setTimeout(function () { atc.removeAttribute('data-added'); atc.disabled = false; render(); }, 1400); }
            return refreshDrawer().then(function () { openDrawer(atc); });
          })
          .catch(function () { form.submit(); });
      });
    }
  }
  document.querySelectorAll('[data-product-root]').forEach(initProduct);

  /* ---------- sticky mobile ATC ---------- */
  var bar = document.querySelector('[data-sticky-atc]');
  /* Observe the real Add to cart button, not the whole .pdp__buy column. The
     column runs ~1400px on a phone, so watching it kept the bar hidden for
     roughly 880px of scrolling after the button itself had gone - the exact
     stretch where the shopper has no way to buy. Watching [data-atc] shows the
     bar the moment the button leaves the viewport and hides it when it returns. */
  var atcTarget = document.querySelector('[data-atc]');
  if (bar && atcTarget && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '-80px 0px 0px 0px' });
    io.observe(atcTarget);
    var barBtn = bar.querySelector('button');
    if (barBtn) barBtn.addEventListener('click', function () {
      /* Click the real submit button rather than calling form.submit(),
         which does not fire the submit event and would skip every guard. */
      var atc = document.querySelector('[data-atc]');
      if (atc && !atc.disabled) atc.click();
    });
  }

  /* ---------- size comparison tabs ---------- */
  document.querySelectorAll('[data-compare]').forEach(function (root) {
    var opts = root.querySelectorAll('[data-compare-pick]');
    function pick(key) {
      root.querySelectorAll('[data-compare-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-compare-panel') !== key;
      });
      opts.forEach(function (o) { o.setAttribute('aria-pressed', o.getAttribute('data-compare-pick') === key ? 'true' : 'false'); });
    }
    opts.forEach(function (o) { o.addEventListener('click', function () { pick(o.getAttribute('data-compare-pick')); }); });
  });

  /* ---------- cart page ---------- */
  function cartChange(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (data) {
        if (r.ok) return data;
        /* Shopify answers a rejection with { message, description, status }.
           Prefer its own wording over anything we could invent. */
        var err = new Error('cart change rejected');
        err.cartError = true;
        err.cartMessage = (data && (data.description || data.message)) || null;
        throw err;
      });
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change], [data-line-remove]');
    if (!btn) return;
    e.preventDefault();
    /* Same markup contract on the cart page and in the drawer. A full reload is
       right for the cart page, but inside the drawer we re-render the section
       instead — and the input lookup is scoped so the two never cross-talk when
       both are in the DOM at once (i.e. on /cart). */
    var drawer = getDrawer();
    var inDrawer = !!(drawer && drawer.contains(btn));
    var scope = inDrawer ? drawer : document;
    var line = Number(btn.getAttribute('data-line'));
    var qty;
    if (btn.hasAttribute('data-line-remove')) qty = 0;
    else {
      var input = scope.querySelector('[data-qty-input][data-line="' + line + '"]');
      if (!input) return;
      /* The steppers derive their target from whatever is in the box, so they
         inherit its blank/garbage cases: Number('') - 1 would floor to 0 and
         silently remove the line. Same contract as the typed path - restore the
         server value and make no request. Removing is the Remove button's job
         (and an explicitly typed 0), never a side effect of a stepper tap. */
      var base = readQty(input);
      if (base === null) return;
      qty = Math.max(0, base + Number(btn.getAttribute('data-qty-change')));
    }
    var controls = lineControls(btn);
    var key = lineKeyFor(btn);
    setControlsDisabled(controls, true);
    cartChange(line, qty).then(function (cart) {
      if (!inDrawer) { window.location.reload(); return; }
      var notice = quantityNotice(cart, key, line, qty);
      return refreshDrawer().then(function (live) {
        /* The swap failed, so the old nodes are still on screen - give them back
           rather than leaving a dead stepper. */
        if (!live) setControlsDisabled(controls, false);
        /* After the swap: the refresh rebuilds the error node, so telling the
           shopper first would wipe the message. */
        if (notice) showDrawerError(notice);
      });
    }).catch(function (err) {
      setControlsDisabled(controls, false);
      if (inDrawer) { showDrawerError(cartErrorText(err)); return; }
      /* Cart page: a server rejection leaves the page stale, so re-render it.
         A network failure changed nothing, so leave the page alone. */
      if (err && err.cartError) window.location.reload();
    });
  });
})();
